import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { throwError } from 'rxjs';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule, {
    // eventCoalescing collapses the burst of touch/mouse/focus events iOS WebKit
    // fires for a single tap into one change-detection pass, instead of one pass
    // per event — a major source of the mat-select/dialog freeze on iOS.
    // runCoalescing additionally collapses CD scheduled from within microtasks
    // (promises, async pipe resolutions) in the same tick into one pass.
    applicationProviders: [
      provideZoneChangeDetection({ eventCoalescing: true, runCoalescing: true }),
    ],
  })
  .catch((e) => throwError(e));
